<section id="app">
  <router-outlet />
</section>
